// extracted by mini-css-extract-plugin
export default {"root":"UserLayout_root__6DSRH","small":"UserLayout_small__xVspc","content":"UserLayout_content__osG5-","isMobile":"UserLayout_isMobile__yNuyO"};